import { z } from 'zod';
/** Dashboard languages. Regional formats (dates, digits) come from the browser, not from here. */
export const SUPPORTED_LOCALES = ['en', 'es', 'fr', 'ar'];
export const LocaleSchema = z.enum(SUPPORTED_LOCALES);
export const DEFAULT_LOCALE = 'en';
//# sourceMappingURL=locale.js.map